module.exports = __webpack_public_path__ + "img/DiHS_Video_Icon_Sr_Tonuebertragung4.b284e309.jpg";